<template>
    <v-dialog v-model="shows" width="960" persistent scrollable :fullscreen="$vuetify.breakpoint.mobile">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-card light v-bind="{ loading }" class="d-flex flex-column" :tile="$vuetify.breakpoint.mobile">
            <v-card-title>
                나누리상품권 주문 상세
                <v-spacer />
                <v-btn v-if="canResend" small color="primary" class="mr-4" :loading="loading" @click="resend"> 문자 재발송 </v-btn>
                <v-btn v-if="canCancel" small color="error" class="mr-4" :loading="loading" @click="cancel"> 결제취소 </v-btn>
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="pt-8" style="flex: 1 0 auto; overflow-y: auto">
                <v-row class="ma-n2">
                    <v-col cols="12" md="6" class="d-flex flex-column pa-2">
                        <nshop-order-view-baseinfo v-bind="{ order }" />
                        <nshop-order-view-member v-bind="{ order }" class="mt-8" />
                    </v-col>
                    <v-col cols="12" md="6" class="pa-2">
                        <nshop-order-view-payment v-bind="{ order }" />
                    </v-col>
                    <v-col cols="12" class="pa-2 mt-6">
                        <nshop-order-view-pins v-bind="{ order }" />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";

import NshopOrderViewBaseinfo from "./nshop-order-view-baseinfo.vue";
import NshopOrderViewMember from "./nshop-order-view-member.vue";
import NshopOrderViewPayment from "./nshop-order-view-payment.vue";
import NshopOrderViewPins from "./nshop-order-view-pins.vue";

export default {
    components: {
        NshopOrderViewBaseinfo,
        NshopOrderViewMember,
        NshopOrderViewPayment,
        NshopOrderViewPins,
    },
    props: {
        _order: { type: String, default: null },
    },
    data: () => ({
        order: {},

        shows: false,
        loading: false,
    }),
    computed: {
        scope() {
            return this.$store.state.scope;
        },
        // 결제취소는 뷰어에게 감춘다 (서버에서도 root·admin 만 허용한다)
        isViewer() {
            return this.scope.includes("viewer");
        },
        canResend() {
            return ["ISSUE_DONE", "PHONE_SENT", "ORDER_USED"].includes(this.order?.state);
        },
        canCancel() {
            if (this.isViewer) return false;

            // 내통장결제(openbank) + 결제~발송 사이 상태에서만. 충전(사용)된 핀이 있으면 숨김(서버도 재검증).
            return (
                this.order?.payment?.method === "openbank" &&
                ["ORDER_PAID", "ISSUE_INIT", "ISSUE_FAIL", "ISSUE_DONE", "PHONE_SENT"].includes(this.order?.state) &&
                !(this.order?.pins || []).some((pin) => pin?.isGained)
            );
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { order } = await api.console.nshop.orders.get({ _id: this._order });
                this.order = order;
            } catch (error) {
                alert(error?.response?.data?.message || error.message);
            } finally {
                this.loading = false;
            }
        },
        async resend() {
            let go = confirm("문자를 재발송하시겠습니까?");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                const { order } = await api.console.nshop.orders.resend.post({ _id: this._order });
                this.order = order;
                this.$emit("search");
                alert("재발송되었습니다.");
            } catch (error) {
                alert(error?.response?.data?.message || error.message);
            } finally {
                this.loading = false;
            }
        },
        async cancel() {
            let go = confirm("결제를 취소하시겠습니까?\n나누리 상품권이 폐기되고 결제금액이 환불됩니다.");
            if (!go) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                const { order } = await api.console.nshop.orders.cancel.post({ _id: this._order });
                this.order = order;
                this.$emit("search");
                alert("결제가 취소되었습니다.");
            } catch (error) {
                alert(error?.response?.data?.message || error.message);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .nshop-order-view-section {
    position: relative;

    .table-label {
        position: absolute;
        left: 0;
        bottom: 100%;
        transform: translateY(50%) scale(0.75);
        color: rgba(0, 0, 0, 0.6);
        font-size: 16px;
    }

    .v-data-table__mobile-row {
        padding: 4px 16px !important;

        &,
        & * {
            height: auto !important;
            min-height: auto;
            font-size: 13px;
            font-weight: normal;
            white-space: pre-line;
        }
    }
}
</style>
